/**
 * Timezone-aware date formatting utilities.
 * Always call with the user's timezone from AuthContext (user.timezone || 'UTC').
 */

export const COMMON_TIMEZONES = [
  { value: 'America/Los_Angeles', label: 'Pacific Time (US & Canada)' },
  { value: 'America/Denver',      label: 'Mountain Time (US & Canada)' },
  { value: 'America/Chicago',     label: 'Central Time (US & Canada)' },
  { value: 'America/New_York',    label: 'Eastern Time (US & Canada)' },
  { value: 'UTC',                 label: 'UTC' },
  { value: 'Europe/London',       label: 'London (UK)' },
  { value: 'Europe/Paris',        label: 'Central European Time' },
  { value: 'Asia/Dubai',          label: 'Dubai (GST)' },
  { value: 'Asia/Kolkata',        label: 'India Standard Time' },
  { value: 'Asia/Singapore',      label: 'Singapore Time' },
  { value: 'Australia/Sydney',    label: 'Sydney (AEST)' },
];

/** Format a UTC ISO datetime string as date + time in the given timezone. */
export function fmtDateTime(isoStr, timezone = 'UTC') {
  if (!isoStr) return '—';
  try {
    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
      timeZone: timezone,
    }).format(new Date(isoStr));
  } catch {
    return new Date(isoStr).toLocaleString();
  }
}

/** Format a UTC ISO datetime string as date-only in the given timezone. */
export function fmtDate(isoStr, timezone = 'UTC') {
  if (!isoStr) return '—';
  try {
    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit', month: 'short', year: 'numeric',
      timeZone: timezone,
    }).format(new Date(isoStr));
  } catch {
    return new Date(isoStr).toLocaleDateString();
  }
}
